import { Injectable, Input } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { ALERTS, AppConstants } from '../common/constants';

import { IMenuOption } from '../models/index';
// Models
import { AlertService } from '../services/alerts.service';
// Services
import { AuthenticationService } from '../services/authentication.service';
import { SessionService } from '../services/session.service';
import { SideBarService } from '../services/side-bar.service';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationGuard implements CanActivate {
  menu: IMenuOption[];
  keys: number[];
  opened: boolean = false;
  @Input() currentUser: string;
  constructor(
    private sessionService: SessionService,
    private alertService: AlertService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private storageService: StorageService,
    private sidebarService: SideBarService
  
  ) {
    this.menu = AppConstants.GetMenu;
    this.authenticationService.currentUser.subscribe(next => this.currentUser = next);
    this.sidebarService.toggler.subscribe((toggle) => (this.opened = toggle));
    this.loadKeys();
    
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    this.currentUser || this.router.navigate(['/login']);
    const TARGET = route.url[0].path;
    const MENU_OPTION = this.FindPath(TARGET);

    if (!(new Date(this.currentUser['ExpireTime']) > new Date())) {
      this.sidebarService.currentPath.next('Inicio');
      this.sessionService.logOut();
      this.alertService.ShowSmallCornerAlert('Lo sentimos, la sesión ha expirado', 3);
      this.sidebarService.toggler.next(false);
    }

    if (!MENU_OPTION) {
      this.alertService.ShowSmallCornerAlert(`No tiene acceso a esta página`, ALERTS.warning);
      this.sidebarService.currentPath.next('Inicio');
      this.router.navigateByUrl('home');
      return false;
    }

    this.sidebarService.currentPath.next(MENU_OPTION.Name);

    if (MENU_OPTION.RequiredPerm === 'V_Home') return true;
    const PERMISSION = this.storageService.GetPermissions().find(x => x.Code === MENU_OPTION.RequiredPerm);

    if (!PERMISSION) {
      this.alertService.ShowSmallCornerAlert(`No tiene acceso a esta página`, ALERTS.warning);
      this.sidebarService.currentPath.next('Inicio');
      this.router.navigateByUrl('home');
      return false;
    }
    return true;
  }

  loadKeys() {
    if (!this.sessionService.session.Active) return;

    this.keys = this.sessionService.session.Keys.split(',');
  }

  FindPath(_path: string): IMenuOption {
    _path = '/' + _path;
    for (let c = 0; c < this.menu.length; c++) {
      if (this.menu[c].Route == _path) {
        return this.menu[c];

      }
      for (let d = 0; d < this.menu[c].Children.length; d++) {
        if (this.menu[c].Children[d].Route == _path) {
          return this.menu[c].Children[d];
        }
        for (let e = 0; e < this.menu[c].Children[d].Children.length; e++) {
          if (this.menu[c].Children[d].Children[e].Route == _path) {
            return this.menu[c].Children[d].Children[e];
          }
        }
      }
    }
  }
}

